module.exports = __webpack_public_path__ + "img/Download-amb-poker.ae4faaf0.png";